import React from 'react';
import { SiteContainer, Wrapper, Flex, FlexItem } from 'core/layout';
import { MetaList } from 'modules';
import {
  Anchor,
  BreadcrumbsConnected,
  Heading,
  Paragraph,
} from 'elements';
import { getParsedDataFromPages } from 'utils/deepProps';
import { RawContent } from 'elements/util';
import tulkojumi from 'utils/tulkojumi';
import {
  Header,
  Tags,
  SectionHeading,
  DocsList,
  DocHeadingItem,
  DocItem,
  StyledPiezimes,
} from './styled';

class Dokumenti extends React.PureComponent {
  render() {
    const {
      postType,
      data: {
        init_page,
        page,
        lang,
        teksti,
      },
    } = this.props;

    const acf = getParsedDataFromPages(page, 'acf');

    let tags = (page.terms[`${postType}_tags`] || []).map(tag => tag.name)
      .join(', ');
    tags = tags && (
      <small>
        {tags}
      </small>
    );

    /* NOTE: Vairs netiek izmantots
    const getFileIcon = (type) => {
      if (type) {
        let icon;
        const [firstChar, ...rest] = type;
        const fileName = `${firstChar.toUpperCase()}${rest.join('')}`;
        try {
          icon = require(`core/icons/components/files/types/${fileName}`).default;
        } catch (error) { }
        return icon;
      }
    } */

    /* NOTE: Vairs netiek izmantots
    const parseFileMimeType = (mimeType) => {
      const [type, subtype] = mimeType ? mimeType.split('/') : [];
      switch (type) {
        case 'text':
        case 'image':
        case 'audio':
        case 'video':
          return type;
          break;
        case 'application':
          const archivePattern = /^(zip)$/ig;
          const [, matchZip] = archivePattern.exec(subtype) || [];
          if (matchZip) {
            return 'archive';
          }

          const docPattern = /^(msword|rtf|vnd.openxmlformats-officedocument.wordprocessingml.document)$/ig;
          const [, matchDoc] = docPattern.exec(subtype) || [];
          if (matchDoc) {
            return 'text';
          }

          const pdfPattern = /^(pdf|x-pdf|x-bzpdf|x-gzpdf)$/ig;
          const [, matchPdf] = pdfPattern.exec(subtype) || [];
          if (matchPdf) {
            return 'text';
          }

          const excelPattern = /^(xlsx|xlsm|xlsb|xltx|xltm|xls|xlt)$/ig;
          const [, matchExcel] = excelPattern.exec(subtype) || [];
          if (matchExcel) {
            return 'excel';
          }

          const presentationPattern = /^(pptx|pptm|ppt|potx|potm|pot|ppsx|ppsm|pps|odp)$/ig;
          const [, matchPresentation] = presentationPattern.exec(subtype) || [];
          if (matchPresentation) {
            return 'presentation';
          }
      }
    } */

    return (
      <SiteContainer>

        <BreadcrumbsConnected
          lang={lang}
          path={init_page.path}
        />

        <Wrapper>
          <article>
            <Header>
              <Flex>
                <FlexItem basis={7 / 12}>

                  <Tags>
                    {tags}
                  </Tags>
                  <Heading>
                    {page.title}
                  </Heading>

                  <MetaList
                    postType={postType}
                    dateCreated={page.date_created}
                    dateModified={page.date_modified}
                    teksti={teksti}
                    lang={lang}
                    acf={acf}
                  />

                  <Paragraph size='large'>
                    {acf.ievadparagrafs}
                  </Paragraph>

                </FlexItem>
              </Flex>
            </Header>

            {/* Dokumenti */}
            {
              acf.dokumenti && Array.isArray(acf.dokumenti) && acf.dokumenti.length > 0 && (
                <main>
                  <Flex>
                    <FlexItem basis={3 / 12}>
                      <SectionHeading level={3}>
                        {tulkojumi(teksti, 'dokumenti')}
                      </SectionHeading>
                    </FlexItem>
                    <FlexItem basis={7 / 12}>

                      <DocsList>
                        {
                          (acf.dokumenti || []).map((doc, i) => {
                            if (doc.acf_fc_layout === 'grupas_nosaukums') {
                              return (
                                <DocHeadingItem key={i}>
                                  <Heading level={4}>
                                    {doc.nosaukums}
                                  </Heading>
                                </DocHeadingItem>
                              );
                            }

                            if (doc.acf_fc_layout === 'Dokuments' && doc.radit) {
                              const fails = doc.fails;
                              const href = doc.url ? doc.url : fails.url;
                              return (
                                <DocItem key={i}>
                                  <Anchor
                                    href={href}
                                    useIcon={false}
                                    title={fails.title}
                                  >
                                    {doc.nosaukums}
                                  </Anchor><br />
                                  <small>
                                    {doc.apraksts}
                                  </small>
                                </DocItem>
                              );
                            }
                          })
                        }
                      </DocsList>

                    </FlexItem>
                  </Flex>
                </main>
              )
            }

            {/* Piezīmes */}
            {
              page.content && (
                <StyledPiezimes>
                  <Flex>
                    <FlexItem basis={3 / 12}>
                      <Heading level={3}>
                        {tulkojumi(teksti, 'piezimes')}
                      </Heading>
                    </FlexItem>
                    <FlexItem basis={7 / 12}>
                      <RawContent content={page.content} />
                    </FlexItem>
                  </Flex>
                </StyledPiezimes>
              )
            }

          </article>
        </Wrapper>

      </SiteContainer>
    );
  }
}

export default Dokumenti;



// WEBPACK FOOTER //
// ./src/pages/Dokumenti/Dokumenti.jsx